import { useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { db, auth } from "../FIREBASE/firebase";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";
import "../CSS/blog.scss";
import { usePageBackground } from "../COMPONENTS/usePageBackground";

interface Trip {
  id: string;
  title: string;
  location: string;
  date: string;
  imageUrl?: string | null;
}

export const BlogPageView = () => {
  const [trips, setTrips] = useState<Trip[]>([]);
  const [loading, setLoading] = useState(true);
  const { user, isAdmin } = useAuth();
  const history = useHistory();
  usePageBackground();

  useEffect(() => {
    db.collection("trips")
      .orderBy("createdAt", "desc")
      .get()
      .then((snap) => {
        setTrips(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<Trip, "id">) })));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="blog">
      <div className="blog__header">
        <div>
          <NavLink to={routeUrls.HOME} className="blog__back">← Hem</NavLink>
          <h1 className="blog__title">Resor</h1>
        </div>
        <div className="blog__header-links">
          <NavLink to={routeUrls.PLACES} className="blog__places-link">🌍 Länder</NavLink>
          {isAdmin && (
            <NavLink to={routeUrls.ADMIN} className="blog__admin-link">+ Lägg till resa</NavLink>
          )}
        </div>
      </div>

      {loading && <p className="blog__empty">Laddar…</p>}

      {!loading && trips.length === 0 && (
        <p className="blog__empty">Inga resor ännu.</p>
      )}

      {!loading && trips.length > 0 && (
        <div className="blog__grid">
          {trips.map((trip, i) => (
            <div
              key={trip.id}
              className={`blog__card${i === 0 || i === 3 ? " blog__card--wide" : ""}`}
              onClick={() => history.push(`/blogg/${trip.id}`)}
            >
              <div className={`blog__card-img${trip.imageUrl ? "" : " blog__card-img--none"}`} style={trip.imageUrl ? { backgroundImage: `url(${trip.imageUrl})` } : undefined} />
              <div className="blog__card-overlay">
                <span className="blog__card-location">{trip.location}</span>
                <h2 className="blog__card-name">{trip.title}</h2>
                <span className="blog__card-date">{trip.date}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="blog__login-row">
        {user && (
          <>
            <NavLink to={routeUrls.PLANNER} className="blog__login-btn">Reseplanerare</NavLink>
            <button
              className="blog__login-btn"
              onClick={() => auth.signOut().then(() => history.push(routeUrls.HOME))}
            >
              Logga ut
            </button>
          </>
        )}
      </div>
    </div>
  );
};
